import { render } from "./AccountInfoPopup.vue?vue&type=template&id=78ef23c0&ts=true"
import script from "./AccountInfoPopup.vue?vue&type=script&lang=ts"
export * from "./AccountInfoPopup.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__